import { Environment, OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";

import React, { Suspense, useRef } from "react";
import { Badge, Col, Image, Row, Spinner } from "react-bootstrap";
import uc from "../../assets/calvin.webp";
import CloudGLTF from "../../components/cloud-gtlf/cloud-gtlf";
import "./home.scss";

interface IHomeprops {
  id?: string;
}
const Home: React.FC<IHomeprops> = (props) => {
  const wRef = useRef(null);
  return (
    <Col sm="12" md="10" style={{ height: "85vh" }} id={props.id}>
      <h1 className="display-5 p-2 monty">Hello, This is Hruday.</h1>
      <h4 className="p-1 monty mb-0">I am an Software Engineer.</h4>
      <h4 className="p-1 monty mb-0">
        Skilled in Full stack development, Internet of drones, ROS, AR/VR
      </h4>
      <Row>
        <Col xs={12} sm={6}>
          <Suspense fallback={<Spinner animation="grow" size="sm" />}>
            <Canvas
              style={{ height: "35vh" }}
              gl={{ logarithmicDepthBuffer: true }}
              shadows
              camera={{ position: [4, 0, 10], fov: 15 }}
            >
              <Suspense fallback={null}>
                <CloudGLTF fast ref={wRef} position={[0, -10, 0]} />
              </Suspense>
              <OrbitControls makeDefault rotateSpeed={2} />
              <Environment preset="park" />
            </Canvas>
          </Suspense>
        </Col>
        <Col xs={12} sm={6}>
          <Image className="float-end calvin-img" src={uc} />
        </Col>
      </Row>

      <Badge bg="none" text="dark" className="mb-3 float-end f-small">
        Drone model from https://fetchcfd.com/profile/jamesw
      </Badge>
    </Col>
  );
};

export default Home;
